import React from "react";
import PagesHeader from "@components/PagesHeader";
import StickyButtonNav from "@components/StickyButtonNav";
import AwardCard from "../../components/AwardCard";
import ArrowIcon from "./img/arrow-icon.svg?react";
import ActivityPoints from "@components/ActivityPoints";
import { Link } from "react-router-dom";
import "./style.scss";
import { staticCoupon } from "../../Constants";
import {
  COUPON_CACHE_TIME,
  COUPON_STALE_TIME,
  getCouponCatalogueLimitedList,
  getCouponCatalogueStandardList,
} from "../../api/coupon";
import {
  PRIZE_CACHE_TIME,
  PRIZE_STALE_TIME,
  getPrizeList,
} from "../../api/prize";
import { useQuery } from "@tanstack/react-query";
import spider from "../Activities/Activities/Idents/quiz_7/img/spider.svg";
import Object from "@components/FindGame";
import {
  applySortCouponsRules,
  isCouponInStock,
  isCouponSoldOut,
} from "@app/Helpers";
import { EasterEgg } from "@pages/EasterEggPage";

export const navItems = [
  { link: "/coupons", label: "Katalog" },
  { link: "/coupons/received", label: "Erhalten" },
];

function MorePointsTile() {
  return (
    <Link to="/activities" className="more-points-tile">
      <div className="content">
        <div className="img-wrapper">
          <div className="img" />
        </div>
        <ActivityPoints>20</ActivityPoints>
        <div className="content-inner">
          <span>Klicken und mehr erfahren</span>
          <div className="flex-wrapper">
            <p>
              Punkte
              <br />
              <strong>sammeln</strong>
            </p>
            <ArrowIcon />
          </div>
        </div>
      </div>
    </Link>
  );
}

export default function CouponsPage() {
  const couponStandardQuery = useQuery({
    queryKey: ["coupon-catalogue-standard-list"],
    queryFn: () => getCouponCatalogueStandardList(),
    staleTime: COUPON_STALE_TIME,
    cacheTime: COUPON_CACHE_TIME,
  });

  const couponLimitedQuery = useQuery({
    queryKey: ["coupon-catalogue-limited-list"],
    queryFn: () => getCouponCatalogueLimitedList(),
    staleTime: COUPON_STALE_TIME,
    cacheTime: COUPON_CACHE_TIME,
  });

  const prizeQuery = useQuery({
    queryKey: ["prize-list"],
    queryFn: () => getPrizeList(),
    staleTime: PRIZE_STALE_TIME,
    cacheTime: PRIZE_CACHE_TIME,
  });

  const prizes = prizeQuery.data?.prizes ?? [];

  const awards = couponStandardQuery.data?.catalogue;
  const partnerAvailable = couponStandardQuery.data?.partnerAvailable;
  const limitedCoupons = couponLimitedQuery.data?.catalogue ?? [];

  const allCoupons = [...applySortCouponsRules([...limitedCoupons, ...awards])];

  const sortedAwards = allCoupons?.sort((a, b) => {
    const isADisabled =
      isCouponSoldOut(a.availabilityLevel) ||
      !isCouponInStock(a) ||
      !a.hasLevel ||
      !a.hasPoints ||
      (a.partner && !partnerAvailable);
    const isBDisabled =
      isCouponSoldOut(b.availabilityLevel) ||
      !isCouponInStock(b) ||
      !b.hasLevel ||
      !b.hasPoints ||
      (b.partner && !partnerAvailable);

    if (isADisabled && !isBDisabled) return 1;
    if (!isADisabled && isBDisabled) return -1;

    if (a.partner && !b.partner) return -1;
    if (!a.partner && b.partner) return 1;

    return 0;
  });

  const sortedAwardsWithStatic = [staticCoupon, ...sortedAwards];

  return (
    <section className="coupons-page">
      <PagesHeader>
        <strong> Punkte eintauschen </strong>
      </PagesHeader>
      {/* <Object
        bottom="object-4"
        uuid={"b8edea17-1d1c-4298-9856-3ce5f9da645b"}
        image={spider}
        innerImage={spider}
        copy={`<p style="font-size:20px"><strong >Glückwunsch!</strong></p><br/>Du hast eine Spinne gefangen!`}
      /> */}
      <div>
        <StickyButtonNav items={navItems} />
        <div className="coupons-list">
          {/* <EasterEgg ident={"halloween2025_4"} direction="right" /> */}
          {prizes.map((e, index) => (
            <AwardCard
              brands={e.catalogue.brands}
              copy={e?.catalogue?.content?.title}
              mobileImg={e.catalogue.thumbnail?.file?.url}
              desktopImg={e.catalogue.hero_image?.file?.url}
              imgDesc={e.catalogue.hero_image?.metadata?.imgDesc}
              highlighted={e.catalogue.highlighted}
              points={e.catalogue.price}
              key={`prize-${index}`}
              availableForStatus={e.catalogue.hasLevel}
              ident={e.catalogue.ident}
              level={e.catalogue.level}
              inStock={e.catalogue.inStock}
              hasPoints={e.catalogue.hasPoints}
              hasLevel={e.catalogue.hasLevel}
              partner={e.catalogue.partner}
              prize={e.uuid}
            />
          ))}
          {sortedAwards.map((e, index) => (
            <AwardCard
              brands={e.brands}
              copy={e?.content?.title}
              mobileImg={e.thumbnail?.file?.url}
              desktopImg={e.hero_image?.file?.url}
              imgDesc={e.hero_image?.metadata?.imgDesc}
              highlighted={e.highlighted}
              points={e.price}
              key={index}
              availableForStatus={e.hasLevel}
              ident={e.ident}
              level={e.level}
              inStock={isCouponInStock(e)}
              hasPoints={e.hasPoints}
              hasLevel={e.hasLevel}
              partner={e.partner}
              onClick={e.onClick}
              availabilityLevel={e.availabilityLevel}
              disabled={
                isCouponSoldOut(e.availabilityLevel) ||
                !isCouponInStock(e) ||
                !e.hasLevel ||
                !e.hasPoints ||
                (e.partner && !partnerAvailable)
              }
              partnerAvailable={partnerAvailable}
            />
          ))}
          <MorePointsTile />
        </div>
      </div>
    </section>
  );
}
